<!-- ./src/pages/admin/Products.vue -->

<template src="./Clientes.html"></template>

<script>
  import usuario from "@/services/usuario";
  import cliente from "@/services/cliente";
  import moment from "moment";
  import { mapMutations } from "vuex";


  export default {
    name: 'home',
    data () {
      return {
        active: 0,
        search: '',
        message: '',
        tarefa: '',
        dialog: false,
        menu: false,
        dialogError: false,
        dialogConfirmation: false,
        dialogBlock: false,
        dialogImage: false,
        dialogMovie: false,
        editando: false,
        carregando: false,
        user: null,
        maskPercent: '##.##',
        maskPercent100: '###.##',
        maskCNPJ: '##.###.###/####-##',
        excluindo: {},
        bloqueando: {},
        usuarios: [],
        clientes: [],
        tipoParcelamento: [
          { tipopParcela: 1, descricao: "1x" },
          { tipopParcela: 2, descricao: "2x" },
          { tipopParcela: 3, descricao: "3x" },
          { tipopParcela: 4, descricao: "4x" },
          { tipopParcela: 5, descricao: "5x" },
          { tipopParcela: 6, descricao: "6x" },
          { tipopParcela: 7, descricao: "7x" },
          { tipopParcela: 8, descricao: "8x" },
          { tipopParcela: 9, descricao: "9x" },
          { tipopParcela: 10, descricao: "10x" },
          { tipopParcela: 11, descricao: "11x" },
          { tipopParcela: 12, descricao: "12x" },
          { tipopParcela: 13, descricao: "13x" },
          { tipopParcela: 14, descricao: "14x" },
          { tipopParcela: 15, descricao: "15x" },
          { tipopParcela: 16, descricao: "16x" },
          { tipopParcela: 17, descricao: "17x" },
          { tipopParcela: 18, descricao: "18x" },
          { tipopParcela: 19, descricao: "19x" },
          { tipopParcela: 20, descricao: "20x" },
          { tipopParcela: 21, descricao: "21x" },
          { tipopParcela: 22, descricao: "22x" },
          { tipopParcela: 23, descricao: "23x" },
          { tipopParcela: 24, descricao: "24x" },
        ],
        model: {
          nome: '',
          usuarios: [],
          etapas: []
        },
        headers: [{
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'Nome'
          },{
            text: 'CNPJ',
            align: 'left',
            sortable: true,
            value: 'Cnpj'
          },{
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'Email'
          },
          { text: 'Ações', value: 'action', sortable: false },
        ]
      }
    },
    computed: {
      computedDateInicio () {
        return this.model.dtInicio ? moment(this.model.dtInicio).format('DD/MM/YYYY') : ''
      }
    },
    async created () {
      await this.buscar();
    },
    methods: {
      buscar: async function () {

        this.setLoading(true);
        this.user = await usuario.getUsuario(this.$store.getters.user._id);
        this.clientes = await cliente.getClientes();
        this.clientes.forEach((item) => {
          item.dtInicioFormat = item.dtInicio ? moment(item.dtInicio).format('DD/MM/YYYY') : ''
        });
        this.usuarios = await usuario.getUsuarios();
        this.setLoading(false);
      },
      novo: async function () {
        this.dialog = true;
        this.editando = false;
        this.model = {
          nome: "",
          etapas: [],
          usuarios: []
        }
      },
      
      deleteItem: async function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          await cliente.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          this.clientes = await cliente.getClientes();
        }
      },
      bloquear: async function (even) {
        if (!this.dialogBlock) {
          this.dialogBlock = true;
          this.bloqueando = even;
        } else {
          this.setLoading(true);
          let res = await cliente.bloquear(even);
          this.dialogBlock = false;
          this.bloqueando = null;
          this.clientes = await cliente.getClientes();
         this.setLoading(false);
        }
      },
      editItem: async function (even) {
        this.usuarios = await usuario.getUsuarios();
        this.dialog = true;
        this.editando = true;
        this.model = even;
        
        this.model.internal = undefined;
        this.model.flags = undefined;
        if (!this.model.etapas) {
          this.model.etapas = []
        }
        if (!this.model.usuarios) {
          this.model.usuarios = []
        }
        if (this.model.dtInicio) {
          this.model.dtInicio = new Date(this.model.dtInicio).toISOString().substr(0, 10);
        }
      },
      save: async function () {
        let errors = await this.$validator.validate();
        if (errors) {
          if (this.editando) {
            let res = await cliente.save(this.model);
            if (res.data && res.data.error) {
              this.message = res.data.error.data;
              this.dialogError = true;
            } else {
              this.clear();
              this.clientes = await cliente.getClientes();
            }
            this.editando = false;
          } else {
            let res = await cliente.save(this.model);
            if (res.data && res.data.error) {
              this.message = res.data.error.data;
              this.dialogError = true;
            } else {
              this.clear();
              this.clientes = await cliente.getClientes();
            }
            this.editando = false;
          }
        }
      },
      clear: async function () {
        this.model = {
          email: "",
          password: ""
        }
        this.editando = false;
        this.$validator.reset();
        this.dialog = false;
        await this.buscar();
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      }),
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/clientes/Clientes.vue